import * as React from 'react';
import { Route, Switch } from 'react-router-dom';

import PATHS from '../../constants/paths';

import PagesHistoryHome from './PagesHistoryHome';

const PagesHistory = () => {
  return (
    <Switch>
      <Route path={PATHS.HOME} exact={true} component={PagesHistoryHome} />
    </Switch>
  );
};

export default PagesHistory;



// WEBPACK FOOTER //
// ./src/containers/PagesHistory/index.tsx